<template>
  <div class="user-list">
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="course_title" label="课程名称"> </el-table-column>
        <el-table-column prop="user_name" label="学员名称"> </el-table-column>
        <el-table-column prop="phone" label="手机号"> </el-table-column>
        <el-table-column prop="order_money" label="课程价格"> </el-table-column>
        <el-table-column prop="play_time" label="学习时长"> </el-table-column>
        <el-table-column prop="create_time" label="购买日期"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { courseOrderList, courseOrderEdit, CourseOrderExport } from "@/api/order.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  data() {
    return {
      course_uuid: "",
      searchParam: {
        keyword_search: "",
      },
      tableData: [],
    };
  },
  mounted() {
    console.log("000000");
    const row = this.$route.query;
    this.query = row;
    console.log(this.query, "ery");
    if (row.uuid) {
      this.course_uuid = row.uuid;
      this.getList();
    }
  },
  methods: {
    addStudent() {
      this.$router.push({ path: "/teacher-add" });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/course-order-detail",
        query: row,
      });
    },
    async getList() {
      if (!this.course_uuid) {
        this.$message.warning("缺少课程id");
        return;
      }
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        course_uuid: this.course_uuid,
      };
      console.log(param);
      const res = await courseOrderList(param);
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
      console.log(res);
    },
    deleteItem() {
      this.$confirm("确定要删除该老师吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.userOption()
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
